import CustomerForm from '../createCustomer/customerForm';

const Information = ({
	setCustomerData,
	setPrescriptionsDocsList,
	prescriptionsDocsList,
	customerData,
	cityList,
	customerDocs,
	setCustomerDocs,
	errors,
	setError,
	isEdit,
	totalOutStandingAmount,
	amountDueFifteenDays,
}) => {
	return (
		<div className="max-w-1297">
			<div className="px-4 py-3">
				<h4 className="summary-title">Summary</h4>

				<div className="d-flex align-items-start ">
					<div className="d-flex flex-column summary-main">
						<p className="summary-label mb-1">Total Outstanding Receivables</p>
						<h4 className="summary-value">₹ {Number(totalOutStandingAmount).toFixed(2)}</h4>
					</div>

					<div className="d-flex flex-column summary-divider">
						<p className="summary-label mb-1">Due In Next 15 Days</p>
						<h4 className="summary-value">₹ {amountDueFifteenDays}</h4>
					</div>
				</div>
			</div>

			<hr className="mx-4 my-0 border-secondary-subtle opacity-25" />

			{/* Summary End */}

			{/* <div
					className="d-flex"
					style={{ gap: '10px', padding: '10px 0px 10px 0px ', fontSize: '1.5rem' }}
				>
					<b style={{ borderBottom: '2px solid #3B58FF', height: '24px' }}>Information</b>
					<p>Referrals</p>
				</div> */}
			<CustomerForm
				setCustomerData={setCustomerData}
				setPrescriptionsDocsList={setPrescriptionsDocsList}
				prescriptionsDocsList={prescriptionsDocsList}
				customerData={customerData}
				cityList={cityList}
				customerDocs={customerDocs}
				setCustomerDocs={setCustomerDocs}
				errors={errors}
				setError={setError}
				isEdit={isEdit}
			/>
		</div>
	);
};
export default Information;
